import { useState, useEffect } from 'react';
import { useAccessibility } from '../../../context/AccessibilityContext/AccessibilityContext';
import Block from '../../../components/Block/Block';
import Button from '../../../components/Button/Button';
import style from './bannerblock.module.scss';
import { useNavigate } from 'react-router-dom';
import sambohome from '../../../assets/sambohome.png';
import sambologo from '../../../assets/sambologo.png';

const BannerBlock = () => {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(false);
    const { settings } = useAccessibility();

    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    const textStyle = {
        '--text-color': settings.contrast !== 'default' 
            ? 'var(--text-primary)' 
            : '#ffffff'
    };

    return (
        <div 
            className={style.bannerContainer}
            style={{
                backgroundImage: `url(${sambohome})`,
                backgroundSize: isMobile ? 'cover' : 'cover',
                backgroundPosition: isMobile ? '70% center' : 'center',
                backgroundRepeat: 'no-repeat'
            }}
        >
            <div className={style.overlay}></div>
            
            <Block
                width="100%"
                height='fit-content'
                background="transparent"
            >
                <div className={style.content} style={{...textStyle}}>
                    <div className={style.left}>
                        <div className={style.wrapperText}>
                            <div className={style.headerRow}>
                                <span className={style.badge}>
                                    Спортивная школа олимпийского резерва
                                </span>
                            </div>
                            
                            <h1 className={style.title}>
                                <span className={style.accent}>"САМБО"</span>
                            </h1>

                            <div className={style.logoRow}>
                                <img 
                                    src={sambologo} 
                                    alt="Самбо логотип" 
                                    className={style.logoUnder}
                                />
                            </div>
                            
                            <p className={style.description}>
                                Раскрываем потенциал с раннего возраста!
                            </p>

                            <div className={style.buttonWrapper}>
                                <Button
                                    color="#FFFFFF"
                                    text='Запись на пробное занятие'
                                    background="transparent"
                                    fontFamily='Roboto, sans-serif'
                                    fontSize={isMobile ? '0.8rem' : '1rem'}
                                    fontWeight='500'
                                    onClick={() => navigate('/programs/')}
                                    className={style.customButton}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Block>
        </div>
    );
};

export default BannerBlock;